import { VALIDATION_PATTERNS } from '@/constants/validation';

/** Lightweight email check for login/auth forms (no zod/sanitization deps). */
export function validateEmail(email: string): boolean {
  return VALIDATION_PATTERNS.EMAIL.test(email);
}
